import { datatableInit } from "../functions/datatableInit";
import Swal from "sweetalert2";
import flatpickr from "flatpickr"
import {select2Init} from "../functions/select2Init";
import { Polish } from "flatpickr/dist/l10n/pl"
import axios from "axios";

import{
    trans,
    CZY_NA_PEWNO_CHCESZ_USUNAC_LOKALIZACJE,
    NIE_ANULUJ,
    LOKALIZACJA_ZOSTALA_USUNIETA,
    TAK_USUN,
    NIE_UDALO_SIE_USUNAC_LOKALIZACJI,
    ZAMKNIJ_BUTTON,
    ANULOWANO_USUWANIE_LOKALIZACJI,
    UZUPELNIJ_WSZYSTKIE_POLA,
    IMPORT_UDANY,
    IMPORT_NIEUDANY,
    BRAK,
    NUMER_LOKALIZACJI,
    ADRES,
    KOD_POCZTOWY,
    NUMER_TELEFONU,
    MAKROREGION,
    REGION,
    OKREG,
    REJON,
}  from '../../../translator';
// import weekSelectPlugin from "flatpickr/dist/plugins/weekSelect/weekSelect";




const loader = window.customLoader;

const locationList = () => {

    $('#search-filters').on('click', () => {
        $('.datatable').DataTable().ajax.reload()
    })

    $('#reset-filters').on('click', () =>  {
        $('#customer').val('').change();
        $('#macroregion').val('').change();
        $('#region').val('').change();
        $('#district').val('').change();
        $('#area').val('').change();
        $('.datatable').DataTable().ajax.reload();
    })

    $(document).on('click', '.remove-location', function (e){
        e.preventDefault()
        const id = $(this).data('id')

        Swal.fire({
            icon: 'question',
            title: trans(CZY_NA_PEWNO_CHCESZ_USUNAC_LOKALIZACJE),
            allowEscapeKey: false,
            allowOutsideClick: false,
            showCancelButton: true,
            cancelButtonText: trans(NIE_ANULUJ),
            showConfirmButton: true,
            confirmButtonText: trans(TAK_USUN),
            cancelButtonColor: '#6c757d',
            confirmButtonColor: '#dc3545'
        }).then(result => {
            if (result.isConfirmed)
            {
                $.ajax({
                    "beforeSend": function (){
                        loader.show()
                    },
                    type: 'post',
                    url: Routing.generate('location_remove', {id: id}),
                    "complete": function (){
                        loader.hide()
                    }
                }).done(d => {
                    if (!d.error)
                    {
                        Swal.fire({
                            icon: 'success',
                            title: trans(LOKALIZACJA_ZOSTALA_USUNIETA),
                            showConfirmButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: trans(ZAMKNIJ_BUTTON),
                            confirmButtonColor: '#3f51b5',
                        }).then( () => {
                            $('.datatable').DataTable().ajax.reload()
                        })
                    }
                    else
                    {
                        Swal.fire({
                            icon: 'error',
                            title: trans(NIE_UDALO_SIE_USUNAC_LOKALIZACJI),
                            text: d.error,
                            confirmButtonText: trans(ZAMKNIJ_BUTTON),
                            confirmButtonColor: '#3f51b5',
                        })
                    }

                })
            }
            else
            {
                Swal.fire({
                    icon: 'warning',
                    title: trans(ANULOWANO_USUWANIE_LOKALIZACJI),
                    confirmButtonText: trans(ZAMKNIJ_BUTTON),
                    confirmButtonColor: '#3f51b5',
                })

            }
        })
    })

    $(document).on('click', '.export-location', function () {

        const url = (Routing.generate('location_export'))
        window.open(url, '_blank')
    })

    $(document).on('click', '.import-location', async function (e) {
        e.preventDefault()


        Swal.fire({
            template: '#my-template',
            preConfirm: () => {
                const client = document.getElementById('import_client').value
                const fileImport = document.getElementById('import_fileImport').files[0]
                if (!fileImport || !client)
                {
                    Swal.showValidationMessage(trans(UZUPELNIJ_WSZYSTKIE_POLA))
                }
                return {
                    client: client, fileImport: fileImport
                }
            },

        }).then((result) => {

            const file = result.value['fileImport']
            const client = result.value['client']

            const data = new FormData()
            data.append( 'file', file )
            data.append( 'customer', client )

            loader.show()

            axios.post(Routing.generate('location_import'), data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }).then(function (response){

                loader.hide()

                if(response['data']['ok'])
                {
                    Swal.fire({
                        icon: 'success',
                        title: trans(IMPORT_UDANY),
                        confirmButtonText: trans(ZAMKNIJ_BUTTON),
                        confirmButtonColor: '#3f51b5',
                    }).then( () => {
                        $('.datatable').DataTable().ajax.reload()
                    })
                }
                else
                {
                    Swal.fire({
                        icon: 'error',
                        title: trans(IMPORT_NIEUDANY),
                        text: response["data"]["error"],
                        confirmButtonText: trans(ZAMKNIJ_BUTTON),
                        confirmButtonColor: '#3f51b5',
                    })
                }
            })
        })
    })

    $('.datatable tbody').on('click', '.open-shop', function () {

        loader.show()

        const id = $(this).data('id')
        const tr = $(this).closest('tr')
        const row = $('.datatable').DataTable().row( tr );

        if ( row.child.isShown() ) {
            row.child.hide();
            tr.removeClass('shown');

            loader.hide()
        }
        else {
            $.ajax({
                type: 'post',
                url: Routing.generate('location_details', {id: id}),
            }).then(result => {

                if (result['number'] == null)
                {
                    result['number'] = trans(BRAK)
                }
                if (result['address'] == null)
                {
                    result['address'] = trans(BRAK)
                }
                if (result['city'] == null)
                {
                    result['city'] = trans(BRAK)
                }
                if (result['zipCode'] == null)
                {
                    result['zipCode'] = trans(BRAK)
                }
                if (result['phoneNumber'] == null)
                {
                    result['phoneNumber'] = trans(BRAK)
                }
                if (result['macroregion'] == null)
                {
                    result['macroregion'] = trans(BRAK)
                }
                if (result['region'] == null)
                {
                    result['region'] = trans(BRAK)
                }
                if (result['district'] == null)
                {
                    result['district'] = trans(BRAK)
                }
                if (result['area'] == null)
                {
                    result['area'] = trans(BRAK)
                }

                row.child(

                    '<table class="location-info" style="padding-left:50px;">' +
                    '<tr>' +
                    '<td class="text-center">trans(NUMER_LOKALIZACJI)</td>' +
                    '<td class="text-center">trans(ADRES)</td>' +
                    '<td class="text-center">trans(KOD_POCZTOWY)</td>' +
                    '<td class="text-center">trans(NUMER_TELEFONU)</td>' +
                    '<td class="text-center">trans(MAKROREGION)</td>' +
                    '<td class="text-center">trans(REGION)</td>' +
                    '<td class="text-center">trans(OKREG)</td>' +
                    '<td class="text-center">trans(REJON)</td>' +
                    '</tr>' +
                    '<tr>' +
                    '<td class="text-center">' + result['number'] + '</td>' +
                    '<td class="text-center">' + result['address'] + ' ' + result['city'] +'</td>' +
                    '<td class="text-center">' + result['zipCode'] + '</td>' +
                    '<td class="text-center">' + result['phoneNumber'] + '</td>' +
                    '<td class="text-center">' + result['macroregion'] + '</td>' +
                    '<td class="text-center">' + result['region'] + '</td>' +
                    '<td class="text-center">' + result['district'] + '</td>' +
                    '<td class="text-center">' + result['area'] + '</td>' +
                    '</tr>' +
                    '</table>'

                ).show();
                tr.addClass('shown');

                loader.hide()
            })
        }
    } );

    $(() => {
        datatableInit('.datatable', {

            'columns': [
                {'name': 'l.number'},
                {'name': 'c.companyName'},
                {'name': 'l.address'},
                {'name': 'l.city'},
                {'name': 'l.zipCode'},
                {'name': 'a.surname'},
                {'name': 'l.remarks'},
                {'name': 'unavailable', 'orderable': false},
                {'name': 'l.comment'},
                {'name': 'l.DateAdd'},
                {'name': 'actions', 'orderable': false},
            ],
            order: [0, 'asc'],
            bServerSide: true,
            stateSave: true,
            paginate: true,
            processing: true,
            bDestroy: true,
            autoWidth: false,
            lengthMenu: [25,50,100],
            ajax: {
                beforeSend: function (){
                    loader.show()
                },
                data: (d) => {
                    d.customer = $('#customer :selected').data('customer')
                    d.macroregion = $('#macroregion :selected').data('macroregion');
                    d.region = $('#region :selected').data('region');
                    d.district = $('#district :selected').data('district');
                    d.area = $('#area :selected').data('area');
                    // d.newLocation = $('#newLocation').is(':checked');
                },
                url: Routing.generate('location_list_ajax'),
                type: "POST",
                complete: function (){
                    loader.hide()
                }
            },
        })

        select2Init('select[data-select=select2]')
    })
}

window.initLocationList = () => {
    locationList()
}